import React, { Component } from 'react';
import partial from 'lodash/partial';
import union from 'lodash/union';
import without from 'lodash/without';
import { CheckBoxField } from 'common/components/form_fields';

export default class MultiSelector extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(field, fieldValue) {
    const { input } = this.props;
    const value = input.value || [];
    let newValue = [];

    if (fieldValue) {
      newValue = union(value, [field]);
    } else {
      newValue = without(value, field);
    }

    input.onChange(newValue);
  }

  render() {
    const { options, input } = this.props;

    return (
            <div className="multi-selector">
              <ul>
              {options.map((option, i) => {
                return (
                  <li>
                    <CheckBoxField key={i} label={option.label} meta={{}}
                      input={{
                        name: option.field,
                        onChange: partial(this.onChange, option.field),
                        value: input.value && input.value.includes(option.field)
                      }} />
                  </li>
                )
              })}
              </ul>
            </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pap/components/common/input_fields/multi_selector.jsx